import { Handle, NodeProps, Position } from 'reactflow';
import { IDimensionNodeData } from './types';
import { ReactFlowNode, ViewRowDiv } from './SchemaEntityRelationsUI';
import ViewFieldsTable from './ViewFieldsTable';
import ViewHeader from './ViewHeader';
import { useCallback, useState } from 'react';
import { getTableFromKey } from '../utils';
import TableJoinMeta from './JoinTableMeta';
import ExpandCollapseButton from './ExpandCollapseButton';

const DimensionNode = ({ data }: NodeProps<IDimensionNodeData>) => {
  const { dataModel, viewKey, fields, isLeft, edgeId, viewTables, join } = data;
  const [expanded, setExpanded] = useState(false);
  const handleToggleExpanded = useCallback(
    () => setExpanded((prevState) => !prevState),
    [],
  );

  const tableNameFunc = useCallback(
    (tableKey: string) => {
      return getTableFromKey(tableKey, dataModel).name;
    },
    [dataModel],
  );

  return (
    <ReactFlowNode>
      <Handle
        type="target"
        position={isLeft ? Position.Right : Position.Left}
        id={edgeId}
      />
      <ViewHeader viewKey={viewKey} viewTables={viewTables} />
      {'description' in join ? (
        <ViewRowDiv>Join: {join.description}</ViewRowDiv>
      ) : (
        <TableJoinMeta meta={join} />
      )}
      <ViewFieldsTable
        expanded={expanded}
        fields={fields}
        tableNameFunc={tableNameFunc}
      />
      {fields.length > 0 && (
        <ExpandCollapseButton
          expanded={expanded}
          onClick={handleToggleExpanded}
        />
      )}
    </ReactFlowNode>
  );
};

export default DimensionNode;
